export const encodeAndComposeNewEmail = (options: {
  to: string;
  subject: string;
  body: string;
}) => {
  const { to, subject, body } = options;
  window.location.href = `mailto:${to}?subject=${encodeURIComponent(
    subject
  )}&body=${encodeURIComponent(body)}`;
};
